import { isThisYear } from 'date-fns';

export default function toDate(Authentication, Utils, dateFilter) {
  'ngInject';

  return function link(date, modifier) {
    let yearFormat = Authentication.user.settings.usTimeFormat ? ', yyyy' : ' yyyy';

    if (modifier === 'no-year-if-current' && isThisYear(Utils.getRealDate(date))) {
      yearFormat = '';
    }

    const format = Authentication.user.settings.usTimeFormat ? 'MMM dd' : 'dd MMM';
    return dateFilter(date, format + yearFormat);
  };
}
